import { lazy, Suspense } from 'react'
import PageMeta from 'src/_shared/components/PageMeta'
import Hero from 'src/pages/Main/components/Hero'

const CallToActionSection = lazy(() => import('src/_shared/components/CallToActionSection'))
const Customers = lazy(() => import('src/pages/Main/components/Customers'))
const Network = lazy(() => import('src/pages/Main/components/Network'))
const Partners = lazy(() => import('src/pages/Main/components/Partners'))
const Services = lazy(() => import('src/pages/Main/components/Services'))
const Statistics = lazy(() => import('src/pages/Main/components/Statistics'))

export const Main = (): JSX.Element => {
	return (
		<>
			<PageMeta
				title="Voltality - Leading EV Charging and eRoaming Network"
				description="Voltality offers a leading eRoaming network and innovative EV charging solutions for corporate fleets and EV infrastructure. Discover our seamless charging experience."
			/>
			<Hero />
			<Suspense fallback={<></>}>
				<Partners />
				<Customers />
				<Network />
				<Services />
				<Statistics />
				<CallToActionSection />
			</Suspense>
		</>
	)
}
